import axios from './axios';

/**
 * Fetch the tenant-wide list of active diversions.
 *
 * Server: GET /api/v1/transportation/routes/active/diversion
 *   - Maps to ActiveRouteDiversionController#list (educe-tec).
 *   - Auth: TRANSPORTATION_MANAGER or ADMINISTRATOR (handled transparently).
 *   - No request body, no query params.
 *   - Response: List<DiversionStatusResponse> — each element carries
 *     id, createdDate, status, notificationId, policy,
 *     suggestedShelterLocation, shelterLocation, cancelledAt,
 *     activeRouteId, routeNumber, routeState, driver (nested
 *     DriverResponse: {id, forename, surname, email, mobilePhone,
 *     busCompany}, nullable when ActiveRoute has no driver).
 *     NO cancelledBy / superseded fields (supersession-internal).
 *
 * The frontend axios baseURL is /api/v1 (see src/api/axios.js + every
 * variants/.../environment.values.js), so the path here drops the prefix.
 *
 * @returns {Promise} axios promise — task 04's saga destructures { data }
 *   from the resolved value (matches src/sagas/Routes.js:239 pattern).
 */
export const getActiveDiversions = () =>
  axios.get('/transportation/routes/active/diversion').then(result =>
    // Compatibility shim: the live deployed server (pre-deploy of the
    // educe-tec fix that wraps this endpoint's response in Response<>)
    // returns a bare `List<DiversionStatusResponse>`. Every other API
    // helper + the saga's `const { data } = ...` destructure assume the
    // envelope shape. Normalize a bare array to `{ data: [...] }` so the
    // saga works consistently both pre- and post-deploy. Becomes a no-op
    // pass-through once the server is on the wrapped contract.
    Array.isArray(result) ? { data: result } : result,
  );
